import {
  CorrecaoDeMarcacao,
  JornadaEmAndamento,
  Marcacao,
  SincronizacaoDoUsuario,
  EstadoSincronizacao,
  MarcacoesEmAndamento,
  MomentoDaJornada
} from './Sincronizador.modelo'
import moment from 'moment'

export function copiarObjetoProfundamente<T> (objetoASerCopiado: T): T | null {
  if (typeof objetoASerCopiado !== 'object') {
    return null
  }
  return JSON.parse(JSON.stringify(objetoASerCopiado))
}

export function obterListasDeIdsDeMarcacoesEmAndamento (sincronizacaoUsuario: SincronizacaoDoUsuario): MarcacoesEmAndamento {
  const jornadaCopiada = copiarObjetoProfundamente<JornadaEmAndamento>(sincronizacaoUsuario.jornada_em_andamento)

  return {
    correcoes_de_marcacao_id: jornadaCopiada?.correcoes_de_marcacao_id || [],
    marcacoes_id: jornadaCopiada?.marcacoes_id || []
  }
}

export function obterListaDeMarcacoes (sincronizacaoUsuario: SincronizacaoDoUsuario) {
  if (!sincronizacaoUsuario.marcacoes) {
    throw new Error('A propriedade marcacoes não existe no objeto de sincronização do usuário')
  }
  return sincronizacaoUsuario.marcacoes
}

export function obterListaDeCorrecoesMarcacoes (sincronizacaoUsuario: SincronizacaoDoUsuario) {
  if (!sincronizacaoUsuario.correcoes_de_marcacao) {
    throw new Error('A propriedade correcoes_de_marcacao não existe no objeto de sincronização do usuário')
  }
  return sincronizacaoUsuario.correcoes_de_marcacao
}

export function substituirMarcacoesCorrigidas (listaDeCorrecoes: CorrecaoDeMarcacao[], listaDeMarcacoes: Marcacao[]) {
  (listaDeCorrecoes || []).forEach(correcao => {
    const marcacaoCorrecaoId = correcao.marcacao_id
    const marcacaoErrada = listaDeMarcacoes.find(marcacao => marcacao.id === marcacaoCorrecaoId)

    if (!marcacaoErrada) {
      listaDeMarcacoes.push({ ...correcao, origem: 'OUTRO' })
      return
    }

    const indexMarcacaoErrada = listaDeMarcacoes.indexOf(marcacaoErrada)
    listaDeMarcacoes.splice(indexMarcacaoErrada, 1)
    listaDeMarcacoes.push({ ...correcao, origem: 'CORRECAO' })
  })
}

export function filtrarMarcacoesPorMomentoDaJornada (listaDeMarcacoes: Marcacao[], momento: MomentoDaJornada) {
  return listaDeMarcacoes
    .filter(marcacao => marcacao.momento_da_jornada === momento) || []
};

export function ordenarMarcacoesPorHorarioDaMarcacao (listaDeMarcacoes: Marcacao[]) {
  return listaDeMarcacoes
    .sort((a, b) => moment(a.horario).diff(moment(b.horario))) || []
};

export function obterMarcacoesDaJornadaEmAndamento (state: EstadoSincronizacao) {
  const jornadaEmAndamento = obterListasDeIdsDeMarcacoesEmAndamento(state.sincronizacaoUsuario)
  const listaDeMarcacoes = obterListaDeMarcacoes(state.sincronizacaoUsuario)
  const listaDeCorrecoes = obterListaDeCorrecoesMarcacoes(state.sincronizacaoUsuario)

  const momentosDaJornada = Object.freeze({
    entrada: MomentoDaJornada.Entrada,
    pausa: MomentoDaJornada.Pausa,
    retorno: MomentoDaJornada.RetornoPausa,
    saida: MomentoDaJornada.Saida
  })

  const listaDeCorrecoesEmAndamento = jornadaEmAndamento.correcoes_de_marcacao_id.map(correcaoId => listaDeCorrecoes.find(correcao => correcao.id === correcaoId)).filter(Boolean) as CorrecaoDeMarcacao[]
  const listaDeMarcacoesEmAndamento = jornadaEmAndamento.marcacoes_id.map(marcacaoId => listaDeMarcacoes.find(marcacao => marcacao.id === marcacaoId)).filter(Boolean) as Marcacao[]

  substituirMarcacoesCorrigidas(listaDeCorrecoesEmAndamento, listaDeMarcacoesEmAndamento)

  const entradas = ordenarMarcacoesPorHorarioDaMarcacao(filtrarMarcacoesPorMomentoDaJornada(listaDeMarcacoesEmAndamento, momentosDaJornada.entrada))
  const pausas = ordenarMarcacoesPorHorarioDaMarcacao(filtrarMarcacoesPorMomentoDaJornada(listaDeMarcacoesEmAndamento, momentosDaJornada.pausa))
  const retornos = ordenarMarcacoesPorHorarioDaMarcacao(filtrarMarcacoesPorMomentoDaJornada(listaDeMarcacoesEmAndamento, momentosDaJornada.retorno))
  const saidas = ordenarMarcacoesPorHorarioDaMarcacao(filtrarMarcacoesPorMomentoDaJornada(listaDeMarcacoesEmAndamento, momentosDaJornada.saida))

  return {
    entrada: [...entradas],
    pausa: [...pausas],
    retorno: [...retornos],
    saida: [...saidas]
  }
}
